import React from 'react'
import styles from './EdofSection5.module.css'
const data = [
    {
        title: "Adaptation",
        desc: "Simultaneous vision can increase adaptation demands for some patients",
        icon: "/Images/icon-02.webp",
    },
    {
        title: "Aberrations",
        desc: "Optical halos, overlapping images & ghosting",
        icon: "/Images/Aberrations.svg",
    },
    {
        title: "Comfort",
        desc: "Irritation from CLs affects vision quality & wearing experience",
        icon: "/Images/Comfort.svg",
    },
    {
        title: "Low Light",
        desc: "Vision quality affected by pupil size",
        icon: "Images/Low-Light-Icon.webp",
    },
    {
        title: "Fitting Complexity",
        desc: "Extended chair time, refits, & managing patient expectations",
        icon: "/Images/icon-04.webp",
    },
    {
        title: "Drop Out",
        desc: "Patient frustration may influence negative sentiment",
        icon: "Images/Frame-04.webp",
    },
];

const EdofSection5 = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>

                {/* Top Card */}
                <div className={styles.topCard}>
                    <div className={styles.redBox}></div>
                    <div className={styles.textBox}>
                        <h2>Current</h2>
                        <p>multifocal  CL <br /> landscape</p>
                    </div>
                </div>

                {/* Curve Line */}
                <div className={styles.curveLine}></div>

                {/* Grid Section */}
                <div className={styles.grid}>
                    {data.map((item, i) => (
                        <div key={i} className={styles.card}>
                            <img src={item.icon} alt="icon" loading="lazy" decoding="async" />
                            <div className={styles.cardText}>
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* EDOF Design Section */}
                <div className={styles.edofSection}>
                    <div className={styles.edofLeft}>
                        <img
                            src="/Images/LeftImage3.webp"
                            alt="Spherical Lens"
                            className={styles.lensImg}
                        loading="lazy" decoding="async" />

                    </div>

                    <div className={styles.edofRight}>
                        <div className={styles.edofText}>
                            <h2>Patented<br />EDOF Design</h2>
                            <h4>A precise equation for every distance.</h4>
                            <p>
                                The novel EDOF design significantly increases the depth of focus at
                                intermediate and near distances.
                            </p>
                        </div>

                        <div className={styles.edofImg}>
                            <img className={styles.desktopImg} src="/Images/Folder_footer2.png" alt="EDOF Curve" loading="lazy" decoding="async" />
                            <img className={styles.MobImg} src="/Images/Folder_footer_mobile.png" alt="EDOF Curve" loading="lazy" decoding="async" />
                            <p className={styles.fdaText}>
                                FDA cleared EDOF technology<br />in a disposable daily lens
                            </p>
                        </div>


                    </div>
                </div>

            </div>
        </div>
    )
}

export default EdofSection5
